module.exports = __webpack_public_path__ + "img/happy.170b5bcc.png";